module.exports = __webpack_public_path__ + "img/wating.d80f58f9.png";